import { getProfilePictureLink, getUsername, useGetPath, clearCookies, dynamicResourceLinks, getBearerToken, getCookies, setCookies, isLoggedIn, ShowConditonally } from "./util";
import CustomLink from "./CustomLink";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { globalContext } from "./App";

const ControlPannel = ({ children, className, ...props }) => {
	const { loggedIn } = useContext(globalContext);
	var path = useGetPath()
	const [profilePicture, setprofilePicture] = useState(getProfilePictureLink());

	useEffect(() => {
		if (isLoggedIn()) {
			axios.get("https://api.pcbang.ma/api/users/me?populate=avatar", {
				headers: {
					Authorization: getBearerToken()
				}
			}).then((res) => {
				// console.log({ "controlpannel": res })
				if (res?.data?.avatar?.url && res?.data?.avatar?.url !== getCookies().pfp) {
					setCookies({ pfp: res?.data?.avatar?.url })
					setprofilePicture(getProfilePictureLink())
				}
				var data = res.data;
				let cookieobj = {
					username: data?.username,
					author: data?.name,
					email: data?.email,
					pfp: data?.avatar?.url
				}
				setCookies(cookieobj)
			}).catch((err) => {
				console.log(err)
				console.log({ err })
			})
		}
	}, [])
	var welcome = 'Welcome\u00A0back,\u00A0' + getUsername()
	return (
		<ShowConditonally cond={loggedIn}>
			<div {...props} className={"pannel " + className}>
				<div className="log">
					<div className="loggedin">{welcome}</div>
					<div className="right">
						<CustomLink className="profilebutton" to="/profile"
						// {...mouseEventStyles(
						// 	{ backgroundColor: "rgba(255, 255, 255, 0.2)" },
						// 	{ backgroundColor: "rgba(255, 255, 255, 0.3)" }
						// )}
						>
							<div
								// src={profilePicture}
								style={{ backgroundImage: `url(${profilePicture})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "50% 50%" }}
								alt="" className="profileimage" />
							<div className="username tooltip">{getUsername()}</div>
						</CustomLink>
						<CustomLink className="image" to={path.startsWith("/blogs") ? path : (path.startsWith("/map") ? "/map" : "/blogs")} onClick={() => {
							// console.log("log out?");
							clearCookies();
						}}
						// {...mouseEventStyles(
						// 	{ backgroundColor: "rgba(255, 255, 255, 0.2)" },
						// 	{ backgroundColor: "rgba(255, 255, 255, 0.3)" }
						// )}
						>
							<div className="tooltip">LOG&nbsp;OUT</div>
							<img src={dynamicResourceLinks("ff09ff").logOutIcon} alt="" className="logout" />
						</CustomLink>
					</div>
				</div>
				<div className="settings">
					{children}
				</div>
				<div className="navpad"></div>
			</div>
		</ShowConditonally>
	);
}

ControlPannel.defaultProps = {
	className: "",
}

export default ControlPannel;